import { UIText1 } from '@cian/ui-kit';
import { Copy16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';
import { copyToClipboard } from '../../../utils/copyToClipboard';

type TUserCardDesktopPhoneProps = {
  phone: string;
  onClick(): void;
};

export const UserCardDesktopPhone: React.VFC<TUserCardDesktopPhoneProps> = ({ phone, onClick }) => {
  const handleOnClick = React.useCallback(() => {
    copyToClipboard(phone);
    onClick();
  }, [onClick, phone]);

  return (
    <div className={styles['container']} data-testid="UserCardDesktopPhone">
      <div className={styles['text']}>
        <UIText1>{phone}</UIText1>
      </div>
      <button onClick={handleOnClick} className={styles['action']}>
        <Copy16 color="gray_icons_100" />
      </button>
    </div>
  );
};
